export default __webpack_public_path__ + "static/media/pro-elevate-cbb-banner-3.44db6e36.jpg";